import Auth0Lock from 'auth0-lock'
import store from '../store'
import router from '../router'

export default class Authenticator {
    constructor() {
        const options = {
            allowSignUp: false,
            language: 'nb',
            allowShowPassword: true,
            autoclose: true,
            redirectUrl: `${window.location.origin}`,
            forgotPasswordLink: `${window.location.origin}/#/forgotpassword`,
            configurationBaseUrl: 'https://cdn.auth0.com'
        }

        this.lock = new Auth0Lock('2AaDR7JGnpmiuWvhHyDkBWgJ9YUV2XaI', 'auth.igive.no', options)
        this.lock.on('authenticated', (authResult) => this.onAuthenticated(authResult))
        // this.lock.on('forgot_password submit', () => console.log('hei'))
    }

    login () {
        this.lock.show({ redirectUrl: `${window.location.origin}` })
    }

    refetchProfile () {
        this.lock.checkSession({}, (error, authResult) => this.onAuthenticated(authResult))
    }

    onAuthenticated (authResult) {
        store.dispatch('auth/setAuthResult', authResult)
        router.push('/')
    }
}